const amountExamsRoutes = [
  {
    path: '/quantidade-exames',
    name: 'amount_exams',
    component: () => import('@/views/amountExams/setAmountExams.view.vue'),
    meta: {
      header: {
        title: 'Quantidade de exames',
      },
    },
  },
  {
    path: '/facilidade-checkin',
    name: 'advantages_checkin',
    component: () => import('@/views/amountExams/advantagesCheckin.view.vue'),
    meta: {
      header: {
        title: 'Atendimento pelo check-in',
      },
    },
  },
];

export default amountExamsRoutes;
